/**
 * `feature:storage_acl_edit` (S8 plan «Pinned additions»): once per submission — the editor's Save (`recursive: 'none'`)
 * and the Propagate dialog's Start (`recursive: <mode>`) — with enum properties only (never a path or an object ID).
 */
import { trackStorageEvent } from '../../services/storageAnalytics';
import type { HnsActionSource } from './hnsDialogTypes';

export type AclEditOutcome = 'ok' | 'started' | 'conflict' | 'refused' | 'error' | 'cancelled' | 'ambiguous';
export type AclEditSource = 'row-menu' | 'toolbar' | 'keyboard' | 'transfers';

/** `notice` = "Propagate again from this directory" in the Transfers panel; the tree opens like the row menu. */
export function aclEditSource(origin: HnsActionSource | undefined): AclEditSource {
  if (origin === 'toolbar' || origin === 'keyboard') return origin;
  return origin === 'notice' ? 'transfers' : 'row-menu';
}

export function trackAclEdit(props: { recursive: 'none' | 'set' | 'modify' | 'remove'; outcome: AclEditOutcome; ownerChanged: boolean; groupChanged: boolean; maskChanged: boolean; source: AclEditSource }): void {
  trackStorageEvent('feature:storage_acl_edit', props);
}

export function outcomeOfError(kind: 'path-changed' | 'acl-changed' | 'ambiguous' | 'refused' | 'error', category: string): AclEditOutcome {
  if (kind === 'path-changed' || kind === 'acl-changed') return 'conflict';
  if (kind === 'ambiguous') return 'ambiguous';
  if (kind === 'refused') return 'refused';
  return category === 'cancelled' ? 'cancelled' : 'error';
}
